import { contentTypes } from '../_constants'
import { BrowserDetect } from '../_helpers/utils'

const initialState = {
    page: {},
    menu: [],
    ie: BrowserDetect() === 'Explorer',
    menuOpen: false,
    notFound: false,
    newsletterMessage: '',
    newsletterError: '',
    gallery: [],
    testimonials: [],
}

export function content(state = initialState, action) {
    switch (action.type) {
        case contentTypes.PAGE_DATA_SUCCESS:
            return {
                ...state,
                page: action.payload,
                notFound: false,
            }
        case contentTypes.PAGE_DATA_FAILURE:
            return {
                ...state,
                notFound: true,
            }
        case contentTypes.MENU_LINKS_SUCCESS:
            return {
                ...state,
                menuLinks: action.payload,
            }
        case contentTypes.SUBSCRIBE_SUCCESS:
            return {
                ...state,
                newsletterMessage: action.payload,
                newsletterError: '',
            }
        case contentTypes.SUBSCRIBE_FAILURE:
            return {
                ...state,
                newsletterMessage: '',
                newsletterError: action.payload,
            }
        case contentTypes.TOGGLE_MENU:
            return {
                ...state,
                menuOpen: action.payload,
            }
        default:
            return state
    }
}
